import { useSelector } from 'react-redux';
import { selectProtocolAutomationForField } from 'features/stepByStepProtocol/store/stepByStepProtocolSelectors';

// The Protocol suggestion for one field of a transaction form, or `null` (no transaction, no protocol,
// or the field is in the protocol's form for the transport type). Cheap: a stable cached entry per field.
export function useProtocolAutomation(transactionId, fieldName) {
    return useSelector((state) => (transactionId == null || !fieldName ? null : selectProtocolAutomationForField(state, transactionId, fieldName)));
}
